// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3w7lt","notes":"Notes_notes__1e9BQ","note":"Notes_note__13o4L","markdown":"Notes_markdown__3xbmZ"};